import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import log from 'pathfinder/utils/log';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { getDeviceMetadata } from 'pathfinder/utils/sponsoredWidgets/DeviceMetadata';
import { getSponsoredSitewideLogoBaseData } from 'pathfinder/modules/SponsoredWidgetsSponsoredSitewideLogoConsumptionModule/helpers/getSponsoredSitewideLogoBaseData';
import SponsoredWidgetsSponsoredSitewideLogoConsumptionModule from 'pathfinder/modules/SponsoredWidgetsSponsoredSitewideLogoConsumptionModule/SponsoredWidgetsSponsoredSitewideLogoConsumptionModule';
export const getSponsoredWidgetsSponsoredSitewideLogoConsumptionModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const device = getDeviceMetadata();
        const data = yield getSponsoredSitewideLogoBaseData(moduleConfig.config.sponsoredSitewideLogos, (_b = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced) !== null && _b !== void 0 ? _b : false, device);
        return renderLogo(moduleConfig, data);
    }
    catch (error) {
        log.error('getSponsoredWidgetsSponsoredSitewideLogoConsumptionModuleMethods error', error);
        return false;
    }
});
function renderLogo(moduleConfig, data) {
    const isHomePage = document.body.classList.contains('f2-page');
    if (!data || (data.isHomePageExcluded === 'true' && isHomePage)) {
        return false;
    }
    const moduleProps = buildModuleProps(moduleConfig, data);
    const render = () => {
        const anchorID = moduleConfig.name.includes('desktop')
            ? '.global-top-navigation__fandom-logo'
            : '.mobile-global-navigation__logo';
        const targetElement = document.querySelector(anchorID);
        const reactRoot = document.createElement('div');
        reactRoot.setAttribute('id', 'sponsored-sitewide-logo');
        targetElement === null || targetElement === void 0 ? void 0 : targetElement.replaceWith(reactRoot);
        ReactDOM.render(React.createElement(SponsoredWidgetsSponsoredSitewideLogoConsumptionModule, moduleProps), reactRoot);
        return reactRoot;
    };
    return {
        render,
    };
}
